import React from "react";

const Mail = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M3.6 6h28.8c.424 0 .831.146 1.131.407.3.26.469.614.469.982V29.61c0 .369-.169.722-.469.982-.3.26-.707.407-1.131.407H3.6c-.424 0-.831-.146-1.131-.407-.3-.26-.469-.613-.469-.982V7.39c0-.368.169-.722.469-.982.3-.26.707-.407 1.131-.407Zm14.496 12.06-10.26-7.563-2.071 2.117 12.352 9.104 12.13-9.111-2.093-2.101-10.056 7.554h-.002Z"
            fill={fill}
        />
    </svg>
);

export default Mail;
